"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var route_heatmap_1 = require("./route_heatmap");
var RouteMap = function (_a) {
    var errorMessage = _a.errorMessage, setRoundColors = _a.setRoundColors, selectedFEId = _a.selectedFEId, assignedVisitData = _a.assignedVisitData, unassignedVisitData = _a.unassignedVisitData, filterRounds = _a.filterRounds, rootType = _a.rootType;
    return (React.createElement("div", null,
        React.createElement(route_heatmap_1.default, { errorMessage: errorMessage, setRoundColors: setRoundColors, selectedFEId: selectedFEId, assignedVisitData: assignedVisitData, unassignedVisitData: unassignedVisitData, filterRounds: filterRounds, rootType: rootType })));
};
exports.default = RouteMap;
